import React from 'react';
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/shared/components";

export const FAQSection: React.FC = () => {
  return (
    <Accordion type="single" collapsible className="w-full font-mono">
      <AccordionItem value="item-1" className="border-b border-neutral-200 dark:border-neutral-800 last:border-0">
        <AccordionTrigger className="text-sm font-bold hover:no-underline py-4">Is my code safe?</AccordionTrigger>
        <AccordionContent className="text-xs text-muted-foreground leading-relaxed pb-4">
          Yes. We do not store your source code. Codii scans your PRs ephemerally to provide analysis and then discards the content. We only store metadata about the scan (e.g., number of issues found).
        </AccordionContent>
      </AccordionItem>

      <AccordionItem value="item-2" className="border-b border-neutral-200 dark:border-neutral-800 last:border-0">
        <AccordionTrigger className="text-sm font-bold hover:no-underline py-4">How does it differ from GitHub Copilot?</AccordionTrigger>
        <AccordionContent className="text-xs text-muted-foreground leading-relaxed pb-4">
          While Copilot helps you write code, Codii acts as a reviewer. It integrates seamlessly via GitHub events and provides an objective second opinion on every PR, catching bugs and pattern violations that might be missed during drafting.
        </AccordionContent>
      </AccordionItem>

      <AccordionItem value="item-3" className="border-b border-neutral-200 dark:border-neutral-800 last:border-0">
        <AccordionTrigger className="text-sm font-bold hover:no-underline py-4">Which languages are supported?</AccordionTrigger>
        <AccordionContent className="text-xs text-muted-foreground leading-relaxed pb-4">
          We support most major languages including Python, TypeScript/JavaScript, Go, Java, Rust, and more. Our multi-model approach allows us to adapt to various frameworks and coding styles effectively.
        </AccordionContent>
      </AccordionItem>

      <AccordionItem value="item-4" className="border-b border-neutral-200 dark:border-neutral-800 last:border-0">
        <AccordionTrigger className="text-sm font-bold hover:no-underline py-4">Can I customize the review rules?</AccordionTrigger>
        <AccordionContent className="text-xs text-muted-foreground leading-relaxed pb-4">
          Yes! On the Dev plan, you can provide custom instructions and rules (e.g., "Always use TDD" or "Prefer functional programming patterns") that Codii will enforce during reviews.
        </AccordionContent>
      </AccordionItem>

       <AccordionItem value="item-5" className="border-b border-neutral-200 dark:border-neutral-800 last:border-0">
        <AccordionTrigger className="text-sm font-bold hover:no-underline py-4">Do I need to install anything on my server?</AccordionTrigger>
        <AccordionContent className="text-xs text-muted-foreground leading-relaxed pb-4">
          No. Codii is a cloud-based service. You simply authenticate with GitHub, and we handle the rest via webhooks and API integrations.
        </AccordionContent>
      </AccordionItem>
    </Accordion>
  );
};
